import { HttpClient } from '@zeta-core';
import {
  ICreateAdvisorCouponRequest,
  ICreateAdvisorCouponResponse,
  APIResponse,
  ICompletePaymentRequest,
  ICompletePaymentResponse,
  ICreditBalanceResponse,
  ICreditHistoryResponse,
  IFlexiblePlanActivationRequest,
  IFlexiblePlanStatusResponse,
  IGetAdvisorCouponCodesResponse,
  IGetAdvisorCouponDetailsResponse,
  IGetAdvisorCouponResponse,
  IGetCalculatedAmountRequest,
  IGetCalculatedAmountResponse,
  IGetInvoiceResponse,
  IGetSubscriptionPlansResponse,
  IInitiatePaymentResponse,
  IInitiateRefundResponse,
  IInitiateRefundRequest,
  ICreditsPurchaseRequest,
} from '@zeta-types';
import { BILLING_SERVICE } from '../services-path';

export const BillingService = () => {
  return {
    getInvoices: ({ advisorId }: { advisorId: string }): APIResponse<IGetInvoiceResponse> =>
      HttpClient.get(`${BILLING_SERVICE}/invoices/advisors/${advisorId}`),

    downloadInvoice: ({
      invoiceId,
      config,
    }: {
      invoiceId: string;
      config: {
        method: string;
      };
    }): APIResponse<IGetInvoiceResponse> => HttpClient.download(`${BILLING_SERVICE}/invoices/${invoiceId}/download`, {}, { method: 'GET' }),

    getInvoiceDetail: ({
      invoiceId,
      config,
    }: {
      invoiceId: string;
      config: {
        method: string;
      };
    }): APIResponse<IGetInvoiceResponse> => HttpClient.download(`${BILLING_SERVICE}/invoices/${invoiceId}/download`, {}, { method: 'GET' }, false, false),

    getSubscriptionPlans: ({ advisorId }: { advisorId: string }): APIResponse<IGetSubscriptionPlansResponse> =>
      HttpClient.get(`${BILLING_SERVICE}/advisor/${advisorId}/plan`),

    getFlexiblePlanStatus: ({ advisorId }: { advisorId: string }): APIResponse<IFlexiblePlanStatusResponse> =>
      HttpClient.get(`${BILLING_SERVICE}/advisor/${advisorId}/flexible-plan/status`),

    activateFlexiblePlan: ({
      advisorId,
      payload,
    }: {
      advisorId: string;
      payload: IFlexiblePlanActivationRequest;
    }): APIResponse<IFlexiblePlanStatusResponse> =>
      HttpClient.post(`${BILLING_SERVICE}/advisor/${advisorId}/flexible-plan/activate`, payload),

    getCalculatedAmount: ({ advisorId, payload }: { advisorId: string; payload: IGetCalculatedAmountRequest }): APIResponse<IGetCalculatedAmountResponse> =>
      HttpClient.post(`${BILLING_SERVICE}/invoices/advisor/${advisorId}/calculate`, payload),

    initiatePayment: ({ invoiceId }: { invoiceId: string }): APIResponse<IInitiatePaymentResponse> =>
      HttpClient.post(`${BILLING_SERVICE}/invoices/${invoiceId}/payment/initiate`),

    completePayment: ({ payload }: { payload: ICompletePaymentRequest }): APIResponse<ICompletePaymentResponse> =>
      HttpClient.post(`${BILLING_SERVICE}/invoices/payment/complete`, payload),

    initiateCreditPayment: ({ payload }: { payload: ICreditsPurchaseRequest }): APIResponse<IInitiatePaymentResponse> =>
      HttpClient.post(`${BILLING_SERVICE}/advisor/credit-events/payment/initiate`, payload),

    completeCreditPayment: ({ payload }: { payload: ICompletePaymentRequest }): APIResponse<ICompletePaymentResponse> =>
      HttpClient.post(`${BILLING_SERVICE}/advisor/credit-events/payment/complete`, payload),

    getCreditBalance: (): APIResponse<ICreditBalanceResponse> => HttpClient.get(`${BILLING_SERVICE}/advisor/credit-events/credit-balance`),

    getCreditHistory: (): APIResponse<ICreditHistoryResponse[]> => HttpClient.get(`${BILLING_SERVICE}/advisor/credit-events`),

    initiateRefund: ({ advisorId, payload }: { advisorId: string; payload: IInitiateRefundRequest }): APIResponse<IInitiateRefundResponse> =>
      HttpClient.post(`${BILLING_SERVICE}/advisor/${advisorId}/credit-refund`, payload),

    getAdvisorCoupon: ({ advisorId, couponId }: { advisorId: string; couponId: string }): APIResponse<IGetAdvisorCouponResponse> =>
      HttpClient.get(`${BILLING_SERVICE}/advisor/advisor-coupons/${advisorId}/coupon/${couponId}`),

    getAdvisorCouponDetails: ({ advisorId }: { advisorId: string }): APIResponse<IGetAdvisorCouponDetailsResponse> =>
      HttpClient.get(`${BILLING_SERVICE}/advisor/advisor-coupons/${advisorId}/coupon-details`),

    getAdvisorCouponCodes: ({ advisorId }: { advisorId: string }): APIResponse<IGetAdvisorCouponCodesResponse> =>
      HttpClient.get(`${BILLING_SERVICE}/advisor/advisor-coupons/${advisorId}/coupon-codes`),
  };
};
